import React, { useState } from 'react';
import {
  TableRow,
  TableCell,
  Button,
  Box,
  Typography,
} from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EquipmentDetails from 'components/popups/EquipmentDetails';
import ImageBaseURL from 'utilities/api/axios';
import Popover from '@mui/material/Popover';

const TableListItem = ({ product, searchQuery }) => {
  const [openDialog, setOpenDialog] = useState(false); // State to manage dialog open/close

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
//hover
const [anchorEl, setAnchorEl] = useState(null);

const handleMouseEnter = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleMouseLeave = () => {
  setAnchorEl(null);
};

const open = Boolean(anchorEl);


  // filter logic
  const query = searchQuery.toLowerCase();
  const filtered =
    product.name?.toLowerCase().includes(query) ||
    product.category?.toLowerCase().includes(query) ||
    product.description?.toLowerCase().includes(query);

  if (!filtered) return null;

  return (
    <TableRow hover>
      {/* Item Details */}
      <TableCell sx={{ width: '25%' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <CardMedia
            component="img"
            image={
              product.image
                ? `${ImageBaseURL.defaults.baseURL}${product.image}`
                : './machine.png'
            }
            alt={product.name}
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              objectFit: 'cover',
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              fontSize: '1.25rem',
              color: '#898989',
              fontWeight: 500,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {product.name}
          </Typography>
        </Box>
      </TableCell>

      {/* Category */}
      <TableCell sx={{ width: '25%' }}>
        <Typography
          noWrap
          sx={{ fontSize: '1.25rem', color: '#7A7A7A', fontWeight: 400 }}
        >
          {product.category || 'N/A'}
        </Typography>
      </TableCell>

      {/* Description */}
     <TableCell
  sx={{
    width: '30%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  }}
>
  <Typography
    noWrap
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    sx={{
      fontSize: '1.25rem',
      color: '#7A7A7A',
      fontWeight: 400,
    }}
  >
    {product.description || 'N/A'}
  </Typography>

  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={handleMouseLeave}
    disableRestoreFocus
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    sx={{
      pointerEvents: 'none', // important for hover behavior
    }}
  >
    <Typography
      sx={{
        p: 2,
        maxWidth: 400,
        fontSize: '1.1rem',
        color: '#444',
      }}
    >
      {product.description || 'N/A'}
    </Typography>
  </Popover>
</TableCell>


      {/* Stock */}
      <TableCell
        align="center"
        sx={{ width: '10%', fontSize: '1.25rem', color: '#7A7A7A' }}
      >
        {product.instances ?? 'N/A'}
      </TableCell>

      {/* Action */}
      <TableCell sx={{ width: '10%' }}>
        <Button onClick={handleOpenDialog}>
          <VisibilityIcon />
        </Button>
        <EquipmentDetails
          open={openDialog}
          onClose={handleCloseDialog}
          machineId={product.id}
          machineDetails={product}
        />
      </TableCell>
    </TableRow>
  );
};

export default TableListItem;
